// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".point-row .amount{text-align:right}.amount,.last-available-at{color:inherit;font-size:inherit}", ""]);
// Exports
module.exports = exports;
